// @flow
export default (n: any) =>
  !Number.isNaN(parseFloat(n)) && Number.isFinite(parseFloat(n));
